import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import ImagesAll from '../assets';
import './../css/Navbar.css'; // Make sure to create this CSS file
import UserDetails from './UserDetails'; // Import the UserDetails component
import { getCurrentUser, getUserNameOpt, detectDeviceType, getIsEventLive, checkAdmin } from '../utils';
import { useAuth } from '../Context';

function Navbar({ isMenuVisible }) {
  const {gUserData} = useAuth();
  let isMobileDevice = (detectDeviceType().toLocaleLowerCase() === "mobile") ? true : false;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showUserDetails, setShowUserDetails] = useState(false); // State for user details popup
  const location = useLocation(); // Get current route location

  const [currentUserData, setCurrentUserData] = useState(getCurrentUser());

  useEffect(() => {
    setCurrentUserData(gUserData);
  }, [currentUserData, gUserData]);

  const profilePhoto = currentUserData?.profilePhotoPath || '';
  const userFullName = getUserNameOpt() || '';

  const toggleMobileMenu = () => {
    setShowUserDetails(false);
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
 
  const toggleUserDetails = () => {
    setIsMobileMenuOpen(false);
    setShowUserDetails(!showUserDetails);
  };

  const closeMobileMenu = () => {
    setShowUserDetails(false);
    setIsMobileMenuOpen(false); // Close the mobile menu
  };

  return (
    <nav className={`cstm-navbar w3-card-2 ${isMobileDevice ? 'mobile' : ''} ${isMenuVisible ? 'visible' : 'hide'}`}>
      <div className="cstm-navbar-container">
        <div className="cstm-navbar-logo">
          {isMobileDevice ? (
            <img src={ImagesAll.Logos.EncoraWhite} alt="Logo" />
          ) : (
            <img src={ImagesAll.Logos.EncoraBlack} alt="Logo" />
          )}          
          <span className='name-of-site'>Customer<br></br> Advisory Board</span>
        </div>
        <div className={`cstm-navbar-menu ${isMobileMenuOpen ? 'active' : 'visible'} ${location.pathname.toLowerCase().indexOf('home') > -1 ? 'all-tabs-show' : ''}`}>
          {checkAdmin() &&
          <>
            {(location.pathname.toLowerCase().indexOf('home') === -1) ? (
              <>
              {/* <HashLink smooth to="/home" className='switch-to-admin d-flex justify-content-center flex-column text-decoration-none ps-3 pe-3' onClick={closeMobileMenu}>
                <small className='text-muted'>Switch to</small>
                <div className='mt-1 fw-bold color-purple'>
                  <span>Attendee</span>
                  <span className='icons icon-lr-arrows ms-1'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-left-right" viewBox="0 0 16 16">
                      <path d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"/>
                    </svg>
                  </span>
                </div>
              </HashLink> */}
              </>
            ):(
              <HashLink smooth to="/dashboard" className='switch-to-admin d-flex justify-content-md-center align-items-center flex-md-column text-decoration-none ps-3 pe-3' onClick={closeMobileMenu}>
                <small className='text-muted'>Switch to</small>
                <div className='ms-1 ms-md-0 mt-md-0 fw-bold color-purple'>
                  <span>Admin</span>
                  <span className='icons icon-lr-arrows ms-1'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-left-right" viewBox="0 0 16 16">
                      <path d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"/>
                    </svg>
                  </span>
                </div>
              </HashLink>
            )}
          </>
        }
        {(location.pathname.toLowerCase().indexOf('home') === -1) &&
          <ul>
            {<li>
              <HashLink smooth to="/dashboard" className={`cstm-nav-link ${location.pathname === '/dashboard' ? 'selected' : ''}`} onClick={closeMobileMenu}>
                Dashboard
              </HashLink>
            </li>}
            <li>
              <HashLink smooth to="/user-management" className={`cstm-nav-link ${location.pathname.indexOf('/user-management') > -1 ? 'selected' : ''}`} onClick={closeMobileMenu}>
                Manage Members
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/event-management" className={`cstm-nav-link ${location.pathname.indexOf('/event-management') > -1 ? 'selected' : ''}`} onClick={closeMobileMenu}>
                Manage Events
              </HashLink>
            </li>
          </ul>
        }
        {(location.pathname.toLowerCase().indexOf('home') > -1) &&
          <ul>
            <li>
              <HashLink smooth to="/Home#home-section" className={`cstm-nav-link ${location.hash === '#home-section' ? 'active' : ''}`} onClick={closeMobileMenu}>
                Home
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/Home#agenda-section" className={`cstm-nav-link ${location.hash === '#agenda-section' ? 'active' : ''}`} onClick={closeMobileMenu}>
                Agenda
              </HashLink>
            </li>
            { getIsEventLive() && 
              <>
                <li>
                  <HashLink smooth to="/Home#travel-section" className={`cstm-nav-link ${location.hash === '#travel-section' ? 'active' : ''}`} onClick={closeMobileMenu}>
                    Travel Details
                  </HashLink>
                </li>            
                <li className={isMobileMenuOpen ? 'hide' : ''}>
                  <HashLink smooth to="/Home#venue-contact-section" className={`cstm-nav-link ${location.hash === '#venue-contact-section' ? 'active' : ''}`} onClick={closeMobileMenu}>
                    Venue & Contact
                  </HashLink>
                </li>
              
                <li className={isMobileMenuOpen ? '' : 'hide'}>
                  <HashLink smooth to="/Home#venue-contact-section" className={`cstm-nav-link ${location.hash === '#venue-contact-section' ? 'active' : ''}`} onClick={closeMobileMenu}>
                    Venue
                  </HashLink>
                </li>
              </>
            }
            <li className={isMobileMenuOpen || !getIsEventLive() ? '' : 'hide'}>
              <HashLink smooth to="/Home#contact-info-section" className={`cstm-nav-link ${location.hash === '#contact-info-section' ? 'active' : ''}`} onClick={closeMobileMenu}>
                Contact
              </HashLink>
            </li>
          </ul>
        }
          <ul>
            <li className={`user-profile ${isMobileMenuOpen ? 'hide' : ''} ${showUserDetails ? 'active' : ''}`} onClick={() => setShowUserDetails(!showUserDetails)}>
              <img 
                src={profilePhoto ? process.env.REACT_APP_API_URL+'/'+profilePhoto : ImagesAll.Members.NoImg} 
                alt={userFullName} 
                className="user-image" 
              />
              <div className='d-flex'>
                { checkAdmin() && <span className="user-is-admin">Admin</span> }
                <span className="user-name">{userFullName}</span>
              </div>
            </li>
          </ul>
        </div>
        <div className={`user-profile on-mobile ${isMenuVisible ? 'visible' : 'hide'}`} onClick={toggleUserDetails}>
          <img 
              src={profilePhoto ? process.env.REACT_APP_API_URL+'/'+profilePhoto : ImagesAll.Members.NoImg} 
              alt={userFullName} 
              className="user-image" 
            />
        </div>

        {/* User Details Popup */}
        {showUserDetails && (
          <div className="user-details-popup" onClick={toggleUserDetails}>
            <UserDetails /> {/* Render the UserDetails component here */}
          </div>
        )}

        
        <div className={`mobile-menu-icon ${isMobileMenuOpen ? 'close-icon' : ''} ${isMenuVisible ? 'visible' : 'hide'}`} onClick={toggleMobileMenu}>
          {/* You can use a hamburger menu icon here */}
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
